// Footer
export const FOOTER_URL_LINK = "https://tlvt.org";
export const FOOTER_LEAD_TEXT = "Shared with people who organize links the same way — from ";
export const FOOTER_LEAD_TEXT_COMPACT = "from ";
export const FOOTER_TITLE = "tlvt";

// Page
export const PAGE_FULL_TITLE = "Link Space";

// Auth/Extension messages (reference only; not yet wired everywhere to minimize churn)
export const AUTH_MESSAGES = {
  verifyEmailBeforeLogin: "Please verify your email before logging in.",
};

export const EXTENSION_SIGN_IN_ERRORS = {
  missingEmail: "Open the sign-in link from the same browser where you requested it in the extension.",
  unverified: "Please verify your email on the LinkSpace website before using the extension.",
  expired: "This sign-in link has expired. Request a new link from the extension.",
  invalidEmail: "The email for this sign-in link is invalid. Request a new link from the extension.",
  generic: "Could not complete extension sign-in. Request a new link from the extension.",
};
